import React, { useState } from 'react';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import { Controller, useForm } from 'react-hook-form';
import { errorStyle } from '../../constants/styles';
import { InnerViewProps } from './types';
import { submitSupportQuery } from './utils';
import { NewTabIcon } from '../Icons';
import { TextInput } from '../Inputs';
import Button from '../Button';

const HelpAttachmentSupportForm: React.FC<InnerViewProps> = ({
  goBack,
  appData,
}) => {
  const user = {
    name: null,
    email: null,
  };
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const getDefaults = () => {
    return {
      name: user?.name ?? null,
      email: user?.email ?? null,
      content: null,
    };
  };

  const {
    handleSubmit,
    formState: { errors },
    reset,
    control,
    // setError,
  } = useForm({
    reValidateMode: 'onChange',
    defaultValues: getDefaults(),
  });

  const onSubmit = async (values: any) => {
    setLoading(true);
    try {
      await submitSupportQuery(appData.appToken, values);
      setSuccess(true);
    } catch (error) {
      // setError('content', { message: 'Failed to submit support query' });
    }

    setLoading(false);
  };

  const cancelForm = () => {
    reset(getDefaults());
    goBack();
  };

  return (
    <>
      <div className="bg-gradient-to-b from-primary-dark to-primary-light p-3 py-5 flex justify-between items-center">
        <div
          onClick={goBack}
          className="cursor-pointer hover:bg-green-700 p-2 rounded"
        >
          <AiOutlineArrowLeft />{' '}
        </div>
        <div className="font-medium text-lg">Contact</div>
        <div className="w-6"></div>
      </div>
      <div className="p-4 text-black border-b border-gray-400 w-full flex items-center justify-between font-medium text-sm">
        Help &amp; Support{' '}
        <a
          className="text-gray-450 hover:text-black cursor-pointer block"
          href={`https://support.djinnapps.com/${appData.appPath}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <NewTabIcon className="w-10 h-10 block" size={20} />
        </a>
      </div>
      {!success && (
        <form className="p-4 text-black" onSubmit={handleSubmit(onSubmit)}>
          <div className="mt-4">
            <label
              htmlFor="name"
              className="mt-2 block text-xs font-light leading-5 text-black mb-1 ml-4 opacity-75"
            >
              Full name
            </label>
            <Controller
              name="name"
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value } }) => (
                <TextInput
                  id="name"
                  placeholder="Enter name here"
                  value={value}
                  onChange={onChange}
                  invalid={!!errors.name}
                  theme="light"
                  disabled={!!user?.email}
                />
              )}
            />
            {errors.name && errors.name.type === 'required' && (
              <span className={errorStyle}>Name is required</span>
            )}
          </div>

          <div className="mt-4">
            <label
              htmlFor="email"
              className="mt-2 block text-xs font-light leading-5 text-black mb-1 ml-4 opacity-75"
            >
              Email Address
            </label>
            <Controller
              name="email"
              control={control}
              rules={{
                required: true,
                pattern:
                  // eslint-disable-next-line
                  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              }}
              render={({ field: { onChange, value } }) => (
                <TextInput
                  type="email"
                  value={value}
                  onChange={onChange}
                  invalid={!!errors.email}
                  placeholder="Enter email here"
                  theme="light"
                  disabled={!!user?.email}
                />
              )}
            />

            {errors.email && errors.email.type === 'required' && (
              <span className={errorStyle}>Email address is required</span>
            )}
            {errors.email && errors.email.type === 'pattern' && (
              <span className={errorStyle}>
                Please enter a valid email address
              </span>
            )}
            {errors.email && errors.email.type === 'api' && (
              <span className={errorStyle}>{errors.email.message}</span>
            )}
          </div>

          <div className="mt-4">
            <label
              htmlFor="content"
              className="mt-2 block text-xs font-light leading-5 text-black mb-1 ml-4 opacity-75"
            >
              Message
            </label>
            <Controller
              name="content"
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value } }) => (
                <TextInput
                  type="textarea"
                  id="content"
                  placeholder="Enter message here"
                  value={value}
                  onChange={onChange}
                  invalid={!!errors.content}
                  theme="light"
                />
              )}
            />
            {errors.content && errors.content.type === 'required' && (
              <span className={errorStyle}>Message is required</span>
            )}
          </div>

          <div className="flex mt-10">
            <div className="ml-20">
              <Button
                text="Back"
                type="button"
                buttonStyle="transparent-black"
                loading={loading}
                disabled={loading}
                onClick={cancelForm}
              />
            </div>
            <Button
              text="Submit"
              type="submit"
              buttonStyle="green"
              loading={loading}
              disabled={loading}
            />
          </div>
        </form>
      )}
      {success && (
        <div className="h-full w-full flex items-center justify-center flex-col mx-auto py-16 text-center">
          <h3 className="text-black font-medium text-2xl">Success</h3>
          <p className="text-gray-450 font-light text-md w-3/4 mx-auto">
            Your message has been successfully sent, we aim to reply to all
            messages within 24 hours
          </p>
          <span className="block w-1/2 mt-10">
            <Button
              text="Back to assistant"
              type="button"
              buttonStyle="green"
              onClick={() => {
                goBack();
              }}
            />
          </span>
        </div>
      )}
    </>
  );
};

export default HelpAttachmentSupportForm;
